//Install
import React, { Component } from "react";
//Install
import { Container, Row, Col } from "react-bootstrap";
//Install
import Header from "../../Header";
//Install
import Footer from "../../Footer";
//Install
import T723BA from "../../../Media/Image/031.jpg";

//Element
class Default extends Component {
    //Element
    componentDidMount() {
        //Element
        document.title = "Sürdürülebilirlik : Temas Elektrik Taahhüt"
        //Element
        document.getElementsByTagName("meta")["description"].content = "Temas Elektrik Taahhüt, Sunduğu Hizmetleri Yürütürken Çevresel, Sosyal ve Ekonomik Sorumlulukları Öncelikli Olarak Benimsemektedir."
        //Element
        let URL = "https://temaselektrik.com/surdurulebilirlik"
        //Element
        let Canonical = document.querySelector("link[rel='canonical']")
        //Element
        Canonical.setAttribute("href", URL);
    }
    //Element
    render() {
        //Element
        const Content = React.createElement("div", { className: "website-application" },
            //Element
            React.createElement(Header, {}),
            //Element
            React.createElement("main", { className: "S6pt64 C96Q4r pEO064 a527eB d3c437" },
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB f1d74t" },
                    //Element
                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB p33e0e" },
                        //Element
                        React.createElement("figure", { className: "S6pt64 C96Q4r pEO064 a527eB yh70s1" })
                    )
                ),
                //Element
                React.createElement("section", { className: "S6pt64 C96Q4r pEO064 a527eB gq620v" },
                    //Element
                    React.createElement(Container, {},
                        //Element
                        React.createElement(Row, {},
                            //Element
                            React.createElement(Col, { md: 12 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB v431h7" },
                                    //Element
                                    React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB yk8549" },
                                        //Element
                                        React.createElement("h1", { className: "S6pt64 C96Q4r pEO064 a527eB u7760y" },
                                            //Element
                                            "Sürdürülebilirlik"
                                        )
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("h2", { className: "S6pt64 C96Q4r pEO064 a527eB q887o2" },
                                        //Element
                                        "Sürdürülebilir Enerji, ",
                                        //Element
                                        React.createElement("strong", {},
                                            //Element
                                            "Yaşanabilir "
                                        ),
                                        //Element
                                        "Dünya"
                                    )
                                )
                            ),
                            //Element
                            React.createElement(Col, { md: 6 },
                                //Element
                                React.createElement("div", { className: "S6pt64 C96Q4r pEO064 a527eB q95k0u" },
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u m-0" },
                                        //Element
                                        "Temas Elektrik Taahhüt, Sunduğu Hizmetleri Yürütürken Çevresel, Sosyal ve Ekonomik Sorumlulukları Öncelikli Olarak Benimsemektedir."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Gezegeni Koruma ve Gelecek Nesillere Yaşanabilir Bir Dünya Bırakma Hedefiyle Enerji Çözümlerinde Verimlilik ve Sürdürülebilirliği Esas Alıyoruz."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Yenilenebilir Enerji Kaynaklarından Maksimum Verim Sağlamak Enerji Üretim, Tüketim Süreçlerini Optimize Etmek, ve Projelerimizi Çevre Dostu Teknolojilerle Hayata Geçirmek, Sürdürülebilirlik Anlayışımızın Temelini Oluşturur."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Ayrıca, Tüm Hizmetlerimizde Sürdürülebilir Malzeme Kullanımı Enerji Tasarrufu ve Atık Yönetimi Konularında En İyi Uygulamaları Benimseyerek, Müşterilerimize Sadece Güvenilir Değil Aynı Zamanda Çevreye Duyarlı Çözümler Sunuyoruz."
                                    ),
                                    //Element
                                    React.createElement("p", { className: "S6pt64 C96Q4r pEO064 a527eB j39v3u" },
                                        //Element
                                        "Temas Elektrik Olarak; Sürdürülebilir Değerleri Koruma ve Kaynakları Gelecek Nesillere Aktarma Sorumluluğu, Tüm Projelerinde ve Hizmetlerinde Hayata Geçirmektedir."
                                    )
                                )
                            )
                        )
                    )
                ),
                //Element
                React.createElement(Footer, {})
            )
        )
        //Element
        return (
            Content
        );
    }
}
//Element
export default Default;